import type Q from 'q';

import type { SchedulePeriod } from 'bundles/course-sessions/types/LearnerCourseSchedule';
import handleResponse from 'bundles/naptime/handleResponse';
import { getCourseSchedule } from 'bundles/ondemand/utils/courseScheduleApi';

export default (courseId: string): Q.Promise<Array<SchedulePeriod>> => {
  if (!courseId) {
    throw new Error('`courseId` is required to get course schedule.');
  }

  return getCourseSchedule(courseId)
    .then(handleResponse)
    .then(({ elements }: any) => elements[0].defaultSchedule.periods);
};
